import React from 'react';

const Logo = (props) => {
    return (
        <div className="mainBlock__top-menu-logo">
            <a href={props.logo.src}>
                <img 
                    src={props.logo.image} 
                    alt={props.logo.alt}
                    className="w-[140px] h-auto sm:w-auto" 
                />
            </a>
        </div>
    );
};

export default Logo;